export default "__VITE_ASSET__DDvPkyfB__"